import ScheduleConfirm from './ScheduleConfirm';

export default ScheduleConfirm;
